import { authHeader } from '../util/authHeader'

import { userService } from './auth-api.service'

import store from '../store'

let baseUrl = process.env.VUE_APP_API_BASE_URL

export const claimService = {
  getAll,
  getByWebReference,
  getStatusByWebReference,
  updateClaimWithRepairOptions,
  getByGadgetWebReference
}

function getAll (params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  if (params) {
    var query = Object.keys(params)
      .map(k => escape(k) + '=' + escape(params[k]))
      .join('&')
  }

  return fetch(baseUrl + `/api/v1/claim` + '?' + query, requestOptions).then(handleResponse)
}

function getByWebReference (webReference) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/claim/` + webReference, requestOptions).then(handleResponse)
}

function getByGadgetWebReference (gadgetWebReference) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/claim/getforgadget/` + gadgetWebReference, requestOptions).then(handleResponse)
}

function getStatusByWebReference (webReference) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/claim/status/` + webReference, requestOptions).then(handleResponse)
}

function updateClaimWithRepairOptions (params) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(params)
  }

  return fetch(baseUrl + `/api/v1/repairoptions/`, requestOptions).then(handleResponseEx)
}

function handleResponseEx (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout()
        location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return Promise.resolve(data)
  })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout()
        location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
